<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <el-button type="primary" :loading="loading" @click="submit(0)">
        发布合同
      </el-button>
      <el-button v-if="(agentId !== 'FX000000000001' && !isNewContract) && !asInterDirect && !isDistribution" type="primary" :loading="loading" @click="dismissedSuggestions()">
        驳回到代理商
      </el-button>
      <el-button v-if="isDistribution" type="primary" :loading="loading" @click="abandonedOrder()">
        废弃合同
      </el-button>
      <el-button type="primary" :loading="loading" @click="submit(1)">
        保存草稿
      </el-button>
      <el-button v-if="isHardWare" type="primary" :loading="loading" @click="hardWare()">
        软件拆分
      </el-button>
    </div>
  </div>
</template>
<script type="es6">
export default {
  data () {
    return {
      loading: false
    };
  },
  props: {
    isNewContract: {
      type: Boolean,
      default: false
    },
    isHardWare: {
      type: [Boolean, String],
      default: false
    },
    contractType: {
      type: String,
      default: null
    },
    agentId: {
      type: String,
      default: null
    },
    asInterDirect: {
      type: Boolean,
      default: false
    },
    isDistribution: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {},
  methods: {
    submit (val) {
      if (!val) {
        this.loading = true;
        this.$parent.submit(val, (val) => {
          this.loading = false;
        });
      } else {
        this.$parent.submit(val, () => {
          this.loading = false;
        });
      }
    },
    Reject () {
      this.loading = false;
      this.$parent.Reject(() => {
        this.loading = false;
      });
    },
    dismissedSuggestions () {
      this.$parent.suggestionInfo(() => {

      });
    },
    abandonedOrder () {
      this.$parent.abandonedOrder(() => {

      });
    },
    hardWare () {
      this.$parent.toHardWare(() => {

      });
    }
  },
  mounted () {
  }
};
</script>
